@if (this.currentCompanyStore.loaded()) {
  <dw-grid-list-page
    [title]="'Doc::Menu:SupplierQuotes' | abpLocalization"
    [activeView]="agGrid.activeView"
    (createAction)="createEntity()"
    [createActionLabel]="'::Add'"
    (deleteAction)="deleteEntities()"
    [enableExportBtn]="enableExport"
    [enableDeleteBtn]="enableDelete"
    (exportAction)="agGrid.export()"
    [enableDuplicateBtn]="selectedEntities().length == 1"
    [showDuplicateBtn]="true"
    (duplicateAction)="duplicateSupplierQuote()"
    [hasQuickSearch]="true"
  >
    <dw-grid-ag-grid
      [columnDefs]="columns"
      [datasource]="datasource"
      (rowClicked)="rowClicked($event)"
      [(selectedRows)]="selectedEntities"
      (selectedRowsClicked)="selectedRowsClicked($event)"
      #agGrid
      [context]="GoliathDocumentEntityNames.SupplierQuote.shortName"
    >
    </dw-grid-ag-grid>
  </dw-grid-list-page>
}
